import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { actions as accountsActions } from "reducers/accounts";
import * as Yup from "yup";
import * as configUtils from "util/config";
import useSchema from "hooks/useSchema";
import { useAccountSelector } from "hooks/useAccounts";
import * as i18n from "util/i18n";
import { CHECKING_ACCOUNT } from "../constants";

export const useAgreementForm = (currency) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { id } = useParams();
    const { accountOptions, accounts, fetching } = useAccountSelector(currency, CHECKING_ACCOUNT);

    const {
        activeEnvironment: { name },
    } = useSelector((state) => state.session);
    const { newAgreement, newAgreementShouldShowLastValues: showLast } = useSelector((state) => state.accounts);
    const { stringRequired, numberRequired } = useSchema();

    useEffect(
        () => () => {
            dispatch(accountsActions.newAgreementShouldShowLastValues(false));
        },
        [],
    );

    const expirationDay = configUtils.getArray("account.agreement.expirationDays", ["7", "14", "21", "31"]);
    const purpose = configUtils.getArray("account.agreement.purposes", [
        "MOVABLE",
        "PROJECT",
        "INVESTMENT",
        "WORKING",
        "PROPERTIES",
        "OTHER",
    ]);

    const expirationDayOptions = i18n.formatOption(expirationDay, "account.agreement.expirationDay");
    const purposeOptions = i18n.formatOption(purpose, "account.agreement.purposes");

    const options = {
        accountOptions,
        expirationDayOptions,
        purposeOptions,
    };

    const commission = `${
        showLast ? newAgreement.commission : configUtils.get("account.agreement.originationFee", "0.3")
    } %`;
    const selectedAccount = accounts.find((selected) => {
        const _id = showLast ? newAgreement.account.idProduct : id;
        return (
            selected.productId === _id && selected.currency === currency && selected.accountType === CHECKING_ACCOUNT
        );
    });

    const initialValues = {
        agreementToRequest: { amount: showLast ? newAgreement.amount : "" },
        account: isEmpty(selectedAccount) ? "" : selectedAccount.productId,
        currency: isEmpty(selectedAccount) ? "" : i18n.get(`account.agreement.currency.${selectedAccount.currency}`),
        expirationDate: showLast ? `${newAgreement.expirationDate}` : "",
        purpose: showLast ? newAgreement.purpose : "",
        rate: 0,
        commission,
    };

    const agreementValidation = Yup.object().shape({
        agreementToRequest: Yup.object().shape({
            amount: numberRequired,
        }),
        account: stringRequired,
        currency: stringRequired,
        expirationDate: stringRequired,
        purpose: stringRequired,
    });

    return {
        fetching,
        options,
        initialValues,
        agreementValidation,
        accounts,
        owner: name,
        id,
        history,
        dispatch,
    };
};

export default useAgreementForm;
